import React, { useEffect, useState } from "react";
import { useDocTitle } from "../utils/hooks";
import WithMainLayout from "../hocs/layouts/MainLayout";
import {
  labels1,
  labels2,
  options,
  defaultData1,
  defaultData2,
} from "./config/charts/DistributionFundsOptions";

import { Doughnut } from "react-chartjs-2";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useAPIs } from "../apis/APIsConfig";
import {
  getDistribucionBalance,
  getInversionFondos,
} from "../services/distribution-funds";
import { convertToMoney } from "../utils/number";
import { colors } from "./config/charts/colors";

ChartJS.register(ArcElement, Tooltip, Legend);

function DistributionFunds() {
  useAPIs();

  useDocTitle("Reparto de Fondos");

  const [chart1Data, setChart1Data] = useState<any>({
    labels: labels1,
    datasets: [],
  });
  const [chart2Data, setChart2Data] = useState<any>({
    labels: labels2,
    datasets: [],
  });

  useEffect(() => {
    getDistribucionBalance().then((res) => {
      if (res) {
        const data1 = { ...defaultData1 };

        const dValues = res.data.value.filter(o => !o.descripcion.includes("Total"))        
        data1.labels = dValues.map((o) => o.descripcion);
        data1.datasets[0].data = dValues.map((o) => o.valor);
        setChart1Data(data1);

        /*
        data1.labels = res.data.value.map((o) => o.descripcion);
        data1.datasets[0].data = res.data.value.map((o) => o.valor * 100);
        setChart1Data(data1);
        */
      }

      getInversionFondos().then((res) => {
        if (res) {
          const data2 = { ...defaultData2 };
          data2.labels = res.data.value.map((o) => o.descripcion);
          data2.datasets[0].data = res.data.value.map((o) => o.valor * 100);
          setChart2Data(data2);
        }
      });
    });
  }, []);

  function getTotalDist() {
    return chart1Data.datasets[0] && chart1Data.datasets[0].data.length
      ? chart1Data.datasets[0].data.reduce((partialSum, a) => partialSum + a, 0)
      : 0;
  }

  function calcPerc(value: number) {
    return convertToMoney((value * 100.0) / getTotalDist());
  }

  return (
    <>
      <div className="block pt-14 pb-[128px]">
        <div className="block space-y-8">
          <div className="content-graphic">
            <h5 className="text-gray-70 lead font-body font-semibold border-b border-gray-5 pb-4 mb-6">
              Distribución de Mis Aportes
            </h5>
            <div className="block lg:flex items-center w-full">
              <div className="rounded-lg bg-gray-5">
                <Doughnut
                  width={208}
                  height={208}
                  data={chart1Data}
                  options={options}
                  className="p-4 md:p-8 min-w-full lg:min-w-[180px] xlg:min-w-[280px] h-[240px] lg:h-[180px] xlg:h-[256px]"
                />
              </div>
              <div className="block w-full pl-0 lg:pl-10 pt-10 lg:pt-0">
                <ul className="block space-y-6 pb-8">
                  {chart1Data.labels.map((chartData, index) => (
                    <li className="description-graphic" key={index}>
                      <div className="block lg:flex items-center justify-between pl-8 lg:pl-4">
                        <p className="text-body-1 text-gray-80 font-body font-normal ">
                          <span
                            style={{
                              backgroundColor: colors[index],
                              marginRight: "5px",
                            }}
                          >
                            &nbsp;&nbsp;
                          </span>
                          {chartData}{" "}
                          <b className="font-semibold">
                            ({calcPerc(chart1Data.datasets[0].data[index])}%)
                          </b>
                        </p>
                        <p className="text-body-1 text-gray-80 font-body font-semibold">
                          RD${" "}
                          {convertToMoney(chart1Data.datasets[0].data[index])}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="block lg:flex items-center justify-between bg-gray-5 rounded p-2">
                  <p className="text-body-1 text-gray-70 font-body font-normal ">
                    Totales <b className="font-semibold">(100%)</b>
                  </p>
                  <p className="text-body-1 text-gray-80 font-body font-semibold">
                    RD$ {convertToMoney(getTotalDist())}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="content-graphic">
            <h5 className="text-gray-70 lead font-body font-semibold border-b border-gray-5 pb-4 mb-6">
              Inversión de Mis Fondos
            </h5>
            <div className="block lg:flex items-center w-full">
              <div className="rounded-lg bg-gray-5 ">
                <Doughnut
                  width={208}
                  height={208}
                  data={chart2Data}
                  options={options}
                  className="p-4 md:p-8 min-w-full lg:min-w-[180px] xlg:min-w-[280px] h-[240px] lg:h-[180px] xlg:h-[256px]"
                />
              </div>
              <div className="block w-full pl-0 lg:pl-10 pt-10 lg:pt-0">
                <ul className="block space-y-6">
                  {chart2Data.labels.map((chartData, index) => (
                    <li className="description-graphic" key={index}>
                      <p className="text-body-1 text-gray-80 font-body font-normal pl-8 lg:pl-4">
                        <span
                          style={{
                            backgroundColor: colors[index],
                            marginRight: "5px",
                          }}
                        >
                          &nbsp;&nbsp;
                        </span>
                        {chartData}{" "}
                        <b className="font-semibold">
                          ({convertToMoney(chart2Data.datasets[0].data[index])}
                          %)
                        </b>
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WithMainLayout(DistributionFunds, "Reparto de Fondos");
